import { cardHeaderClasses, styled, Typography } from '@mui/material';

import { CircularProgress } from '../../atoms/CircularProgress';
import { Tag } from '../../atoms/Tag';
import { CardResource } from '../CardResource';
import { type ResourceSectionCardProps, useResourceSectionCard } from './useResourceSectionCard';

type Props = ResourceSectionCardProps;

const CONTENT_MAX_HEIGHT = 360;

const SectionCardRoot = styled(CardResource)({
  [`& .${cardHeaderClasses.action}`]: {
    alignSelf: 'center',
    margin: 0,
  },
});

const ScrollArea = styled('div')(({ theme }) => ({
  maxHeight: CONTENT_MAX_HEIGHT,
  overflowY: 'auto',
  paddingBlock: theme.spacing(1),
  paddingInline: theme.spacing(2),
}));

const Loading = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  paddingBlock: theme.spacing(2),
}));

const EmptyLabel = styled(Typography)(({ theme }) => ({
  paddingBlock: theme.spacing(2),
}));

export function ResourceSectionCard(props: Props) {
  const hook = useResourceSectionCard(props);

  return (
    <SectionCardRoot
      variant={props.variant}
      title={props.title}
      action={<Tag color={hook.countColor} label={props.count} />}
      fullHeight
      disableCardContent
      data-testid={props['data-testid'] ?? 'resource-section-card'}
    >
      <ScrollArea aria-busy={hook.state === 'loading'}>
        {hook.state === 'loading' ? (
          <Loading>
            <CircularProgress aria-label="Chargement" />
          </Loading>
        ) : hook.state === 'empty' ? (
          <EmptyLabel variant="noItem">{props.emptyLabel}</EmptyLabel>
        ) : (
          props.children
        )}
      </ScrollArea>
    </SectionCardRoot>
  );
}

export type { Props as ResourceSectionCardProps };
